import { useFieldArray, useFormContext } from 'react-hook-form';
import { Table } from 'components/shared/Table';
import { SimpleTextCell } from 'components/Table/Cells/SimpleTextCell';
import {
  IntegrationSettingsEntry,
  IntegrationSettingsForm,
  IntegrationSettingsUserLevelForm,
} from 'modules/integrationSettings/types';
import { InputField } from 'components/form';
import { IntegrationSettingsTypedInput } from '../typedInput';

interface UserTabProps {
  integrationSettings: IntegrationSettingsEntry[];
  tableData: IntegrationSettingsUserLevelForm[];
}

export const IntegrationSettingsTable = ({ integrationSettings, tableData }: UserTabProps) => {
  const { control } = useFormContext<IntegrationSettingsForm>();

  const columns = [
    {
      Header: 'Name',
      accessor: 'fullName',
      Cell: ({ original }: any) => <SimpleTextCell value={original.fullName} />,
    },
    {
      Header: 'Title',
      accessor: 'title',
      Cell: ({ original }: any) => <SimpleTextCell value={original.title} />,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: ({ original }: any) => <SimpleTextCell value={original.email} />,
    },
  ]
    .concat(
      integrationSettings.map(setting => {
        return {
          accessor: setting.name,
          Header: setting.displayName,
          Cell: ({ original, index }: any) => (
            <IntegrationSettingsTypedInput
              key={original.userProfileId}
              dataKey={original.userProfileId}
              integrationSettingsEntry={setting}
            />
          ),
          filterable: false,
          sortable: false,
        };
      })
    )
    .map(header => ({
      ...header,
      resizable: false,
      headerClassName: 'customHeader',
    }));

  return <Table<IntegrationSettingsUserLevelForm> tableData={tableData} columns={columns} />;
};
